import { render, staticRenderFns } from "./edit-agent-comment.vue?vue&type=template&id=04d569d0&"
import script from "./edit-agent-comment.vue?vue&type=script&lang=js&"
export * from "./edit-agent-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports